import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { UnitSelectorViewModel } from "src/EnterpriseAdministration/unitManipulation/unitManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile } from "src/uicomponents/components/utilities";
import { FileSelectorViewModel, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { BrandSelectorViewModel } from "../brandManipulation/brandManipulation-viewModel";
import { ColorSelectorViewModel } from "../colorManipulation/colorManipulation-viewModel";
import { CountrySelectorViewModel } from "../countryManipulation/countryManipulation-viewModel";
import { PartNumberSearchViewModel, PartNumberSelectorViewModel } from "../partNumberManipulation/partNumberManipulation-viewModel";
import  { ProductManipulationView } from "./productManipulation-view"
import { CarBrandSelectorViewModel } from "../carBrandManipulation/carBrandManipulation-viewModel";

export class ProductManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت محصول ها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.products = ObservableArray.create<product>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
        this.fileSelector = new FileSelectorViewModel(this);
        this.fileSelectorForIndex = new FileSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductManipulationView();
    }
    public getTypeId(): string {
        return "VM-918F9791-ADE7-4195-A720-A261F2C2E3AA"
    }
    public set products(v: ObservableArray<product>) { this._products = v; } public get products(): ObservableArray<product> { return this._products;} private _products: ObservableArray<product>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set fileSelectorForIndex(v: FileSelectorViewModel) { this._fileSelectorForIndex = v; } public get fileSelectorForIndex(): FileSelectorViewModel { return this._fileSelectorForIndex;} private _fileSelectorForIndex: FileSelectorViewModel;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllProduct',{
                FilteringInformation:filteringInformation
            });
            this.products.update(...result.Products.map((q,i)=>{
                let r = new product(this);
                r.rowNumber = i+1;
                r.id = q.Id;
                r.pncId = q.PncId;
                r.productIndex = q.ProductIndex;
                r.pncName = q.PncName;
                r.partNumberId = q.PartNumberId;
                r.partNumberName = q.PartNumberName;
                r.brandId = q.BrandId;
                r.brandName = q.BrandName;
                r.colorId = q.ColorId;
                r.colorName = q.ColorName;
                r.carModelId = q.CarModelId;
                r.carModelName = q.CarModelName;
                r.countryId = q.CountryId;
                r.countryName = q.CountryName;
                r.unitId = q.UnitId;
                r.unitName = q.UnitName;
                r.enabled = !q.IsDisabled;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestProductCreation(){
        let editor = new productEditor(this,new InsertServerUpdater());
        editor.readonly = false;
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async productUpdater(product:product){
        let editor = new productEditor(this,new UpdateServerUpdater());
        editor.readonly = true;
        product.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportProductsIntoExcelFile',{
            });
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            downloadFile(result.ExcelFile, `export_products.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async exportProductIndex(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportProductIndex',{
            });
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            downloadFile(result.ExcelFile, `export_products_index.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async importProductIndex(){
        try {
            let errors :string[]= [];
            if(!this.fileSelectorForIndex?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ImportProductIndex',{
                ExcelFile : this.fileSelectorForIndex.filecontent
            });
            if (result.IsSuccessful == true && result.IsValid == true) {    
                await this.messageBoxConfirmSuccess('شناسه کالاها با موفقیت بروزسانی شد.','عملیات موفق');
                this.refresh();
            } else {
                downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                throw 'متن خطا در فایل دانلود شده است.';
            }
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning(ex,'خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateBatchProductsFromExcel',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == false) {
                // if (result.Faults[0].Parameters.FaultId === "63FB3D0F-CD85-4169-BCCA-E6ED9F8716AB") {
                //     throw 'شناسه ها تکراری است.';
                // } else if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A") {
                //     throw 'کالا تکراری است.';
                // } else {
                    downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                    throw 'متن خطا در فایل دانلود شده است.';
                // } 
            }else {
                await this.messageBoxConfirmSuccess('کالاها با موفقیت بروزسانی شد.','عملیات موفق');
                this.refresh();
                return result;
            }
        } catch (ex) {
            await this.messageBoxConfirmWarning(ex,'خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async toggle(id:any){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ToggleProductDisable',{
                Id:id
            });
            if (result.IsSuccessful == false) {
                throw "new Error";
            }
            if (result.IsDisabled == false) {
                await this.messageBoxConfirmSuccess('کالا فعال شد','عملیات موفق');
            } else {
                await this.messageBoxConfirmSuccess('کالا غیر فعال شد','عملیات موفق');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }

}

export class product extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ProductManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set rowNumber(v: string) { this._rowNumber = v; } public get rowNumber(): string { return this._rowNumber;} private _rowNumber: string;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set pncId(v: string) { this._pncId = v; } public get pncId(): string { return this._pncId;} private _pncId: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set partNumberId(v: string) { this._partNumberId = v; } public get partNumberId(): string { return this._partNumberId;} private _partNumberId: string;
    public set partNumberName(v: string) { this._partNumberName = v; } public get partNumberName(): string { return this._partNumberName;} private _partNumberName: string;
    public set brandId(v: string) { this._brandId = v; } public get brandId(): string { return this._brandId;} private _brandId: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName;} private _brandName: string;
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set colorId(v: string) { this._colorId = v; } public get colorId(): string { return this._colorId;} private _colorId: string;
    public set colorName(v: string) { this._colorName = v; } public get colorName(): string { return this._colorName;} private _colorName: string;
    public set countryId(v: string) { this._countryId = v; } public get countryId(): string { return this._countryId;} private _countryId: string;
    public set countryName(v: string) { this._countryName = v; } public get countryName(): string { return this._countryName;} private _countryName: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId;} private _unitId: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set enabled(v: boolean) { 
        this._enabled = v; 
        this.enabledLabel = v ? "فعال" : "غیرفعال";
    } public get enabled(): boolean { return this._enabled;} private _enabled: boolean;
    public set enabledLabel(v: string) { this._enabledLabel = v; } public get enabledLabel(): string { return this._enabledLabel;} private _enabledLabel: string;
    
    private _typedParent:ProductManipulationViewModel;

    clone(parent:ProductManipulationViewModel):product{
        let u = new product(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(product:product){
        product.id = this.id;
        product.productIndex = this.productIndex;
        product.setPartNumberId(this.getPartNumberId(),this.pncName);
        product.setCountry(this.getCountryId(),this.countryName);
        product.setColor(this.getColorId(),this.colorName);
        product.setBrand(this.getBrandId(),this.brandName);
        product.setModel(this.getModelId(),this.carModelName);
        product.setUnit(this.getUnitId(),this.unitName);
    }

    async edit(){
        this._typedParent.productUpdater(this);
    } 

    setPartNumberId(id: string, name: string) {
        this.partNumberId = id;
        this.partNumberName = name;
    }
    
    getPartNumberId() {
        return this.partNumberId;
    }    

    setBrand(id: string, name: string) {
        this.brandId = id;
        this.brandName = name;
    }
    
    getBrandId() {
        return this.brandId;
    }    

    setColor(id: string, name: string) {
        this.colorId = id;
        this.colorName = name;
    }

    getColorId() {
        return this.colorId;
    }    

    setModel(id: string, name: string) {
        this.carModelId = id;
        this.carModelName = name;
    }

    getModelId() {
        return this.carModelId;
    }    

    setCountry(id: string, name: string) {
        this.countryId = id;
        this.countryName = name;
    }
    
    getCountryId() {
        return this.countryId;
    }    

    setUnit(id: string, name: string) {
        this.unitId = id;
        this.unitName = name;
    }
    
    getUnitId() {
        return this.unitId;
    }    

    async toggle(){
        let result:string; 
        if(this.enabled == true) {
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن کالا');
        } else {
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','فعال کردن کالا');
        }
        if(result=='yes'){
            this._typedParent.toggle(this.id);
        }
    }    
}

interface IServerUpdater{
    execute(product:product):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'محصول با موفقیت ثبت شد.';
    }
    async execute(product: product): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateProduct',{
            PartNumber:product.getPartNumberId(),
            Country:product.getCountryId(),
            Color:product.getColorId(),
            Brand:product.getBrandId(),
            CarModel:product.getModelId(),
            ProductIndex:product.productIndex,
            Unit:product.getUnitId()
        });
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw "این کالا قبلا تعریف شده است";
        }
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "63FB3D0F-CD85-4169-BCCA-E6ED9F8716AB")
                throw "شناسه تکراری است.";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'محصول با موفقیت به روز رسانی شد.';

    }
    async execute(product: product): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/SetProductIndex',{
            ProductId:product.id,
            ProductIndex:product.productIndex
        });
        
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "63FB3D0F-CD85-4169-BCCA-E6ED9F8716AB")
                throw "شناسه تکراری است.";
        }
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class productEditor extends product implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ProductManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.brandSelector = new BrandSelectorViewModel(this);
        this.colorSelector = new ColorSelectorViewModel(this);
        this.countrySelector = new CountrySelectorViewModel(this);
        this.unitSelector = new UnitSelectorViewModel(this);
        this.partNumberSelector = new PartNumberSearchViewModel(this);
        this.carModelSelector = new CarBrandSelectorViewModel(this);
        this.partNumberSelector.onSelectionChanged = q=>{
            this.pncName = q.pncName;
            this.partNumberName = q.code;
        }
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set brandSelector(v: BrandSelectorViewModel) { this._brandSelector = v; } public get brandSelector(): BrandSelectorViewModel { return this._brandSelector;} private _brandSelector: BrandSelectorViewModel;
    public set partNumberSelector(v: PartNumberSearchViewModel) { this._partNumberSelector = v; } public get partNumberSelector(): PartNumberSearchViewModel { return this._partNumberSelector;} private _partNumberSelector: PartNumberSearchViewModel;
    public set colorSelector(v: ColorSelectorViewModel) { this._colorSelector = v; } public get colorSelector(): ColorSelectorViewModel { return this._colorSelector;} private _colorSelector: ColorSelectorViewModel;
    public set carModelSelector(v: CarBrandSelectorViewModel) { this._carModelSelector = v; } public get carModelSelector(): CarBrandSelectorViewModel { return this._carModelSelector;} private _carModelSelector: CarBrandSelectorViewModel;
    public set countrySelector(v: CountrySelectorViewModel) { this._countrySelector = v; } public get countrySelector(): CountrySelectorViewModel { return this._countrySelector;} private _countrySelector: CountrySelectorViewModel;
    public set unitSelector(v: UnitSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitSelectorViewModel { return this._unitSelector;} private _unitSelector: UnitSelectorViewModel;
    public set readonly(v: boolean) { this._readonly = v; } public get readonly(): boolean { return this._readonly;} private _readonly: boolean;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(this.readonly == false && stringIsNullOrEmpty(this.getPartNumberId())){
            result.push('کد محصول مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getColorId())){
            result.push('رنگ مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getModelId())){
            result.push('نوع خودرو مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getCountryId())){
            result.push('کشور مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getUnitId())){
            result.push('واحد مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getBrandId())){
            result.push('برند مشخص نشده است.')
        } 
        return result;
    }

    setPartNumber(id: string, name: string) {
        this.partNumberSelector.selectById(id);
    }

    getPartNumberId() {
        return this.partNumberSelector.selectedItem?.id;
    }

    setColor(id: string, name: string) {
        this.colorSelector.selectById(id);
    }

    getColorId() {
        return this.colorSelector.selectedItem?.id;
    }

    setModel(id: string, name: string) {
        this.carModelSelector.selectById(id);
    }

    getModelId() {
        return this.carModelSelector.selectedItem?.id;
    }
    
    setCountry(id: string, name: string) {
        this.countrySelector.selectById(id);
    }

    getCountryId() {
        return this.countrySelector.selectedItem?.id;
    }

    setBrand(id: string, name: string) {
        this.brandSelector.selectById(id);
    }

    getBrandId() {
        return this.brandSelector.selectedItem?.id;
    }
    
    setUnit(id: string, name: string) {
        this.unitSelector.selectById(id);
    }
    
    getUnitId() {
        return this.unitSelector.selectedItem?.id;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت محصول');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}